import React from 'react'

import { WizClassifySelect,WizAuthority, WizClassifySelectRe, WizTableForm } from '@/containers/common';
export  function  _tableFormProps(entityType) {
    let config = { columns: [], tableApi: {} }
    let other = {
        selectType: 'radio'
    }
    switch (entityType) {
        case 0:
            config = WizTableForm.Config.program()
            break
        case 1:
            config = WizTableForm.Config.exam()
            break
        case 2:
            break
        case 26:
            //直播
            config = WizTableForm.Config.topic()
            break
        case 4:
            break
        case 5:
            break
        case 6:
            break
        default:
            other.disabled = true
    }
    let tableFormProps = {
        ...config,
        ...other
    }
    return tableFormProps
}
